import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {translate} from "react-i18next"

import NotificationList from "../NotificationList"
import Button from "../Button"

import styles from "./styles.css"

class NotificationBadge extends PureComponent {
  static propTypes = {
    unreadCount: PropTypes.number,
    notifications: PropTypes.arrayOf(PropTypes.object),
    onClick: PropTypes.func,
    onReadAll: PropTypes.func,
    onGotoNotifications: PropTypes.func
  }

  static defaultProps = {
    unreadCount: 0,
    notifications: [],
    onClick: (_path, _notification) => {},
    onReadAll: () => {},
    onGotoNotifications: () => {}
  }

  state = {
    active: false
  }

  constructor(props) {
    super(props)

    this._onClick = this._onClick.bind(this)
    this._onReadAll = this._onReadAll.bind(this)
    this._onGotoNotifications = this._onGotoNotifications.bind(this)
  }

  _toggleActive() {
    this.setState(prevState => {
      return {
        ...prevState,
        active: !prevState.active
      }
    })
  }

  _onClick(path, notification) {
    this._toggleActive()
    this.props.onClick(path, notification)
  }

  _onReadAll() {
    this._toggleActive()
    this.props.onReadAll()
  }

  _onGotoNotifications() {
    this._toggleActive()
    this.props.onGotoNotifications()
  }

  render() {
    const {notifications, unreadCount, t} = this.props

    return (
      <div className={styles.Wrapper}>
        <button
          className={`${styles.Badge} ${this.state.active && "active"}`}
          onClick={() => this._toggleActive()}
        >
          <i className="icon-bell" />
          {unreadCount >= 1 && <span className="count">{unreadCount}</span>}
        </button>
        <div
          className={`${styles.ListWrapper} ${this.state.active && "active"}`}
        >
          <Button
            theme="white"
            className="button--notifications"
            onClick={this._onGotoNotifications}
          >
            {t("Benachrichtigungen")}
          </Button>
          <div className={styles.List}>
            <NotificationList
              notifications={notifications}
              onClick={this._onClick}
            />
          </div>
          <div className={styles.Buttons}>
            <Button
              size="small"
              theme="white"
              className="button--read-all"
              onClick={this._onReadAll}
            >
              {t("Alle als gelesen markieren")}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default translate()(NotificationBadge)



// WEBPACK FOOTER //
// ./src/components/NotificationBadge/index.js